import type { Feature, GeoJsonProperties, Point } from "geojson";

export function hasTaCodePoints(features: Array<Feature<Point, GeoJsonProperties>>): boolean {
  const first = features?.[0];
  return typeof (first?.properties as any)?.ta_code === "string" && !!(first?.properties as any)?.ta_code;
}
